import {
  AlignmentType,
  Document,
  Header,
  HorizontalPositionRelativeFrom,
  ImageRun,
  Paragraph,
  Table,
  TableCell,
  TableRow,
} from 'docx'
import sscLogo from '@/assets/logo3.png'
import tlaxcalaLogo from '@/assets/logo2.png'
import watermarkLogo from '@/assets/watermark.png'
import BaseHeader from '../BaseHeader'
import BaseText from '../BaseText'
import BaseFooter from '../BaseFooter'

const LETTER_PAGE_SIZE = {
  width: 12240,
  height: 15840,
  orientation: 'portrait',
}
class ConstanciaNoAdeudoArmeria {
  constructor({ nombre = '', area = '', fecha = '' } = {}) {
    this.nombre = nombre
    this.area = area
    this.fecha = fecha || new Date().toISOString().slice(0, 10)
  }
  formatearFechaLarga(fecha) {
    if (!fecha) return { dia: '', mes: '', anio: '' }
    let year, month, day
    if (fecha.includes('/')) {
      ;[day, month, year] = fecha.split('/')
    } else {
      ;[year, month, day] = fecha.split('-')
    }
    const meses = [
      '',
      'enero',
      'febrero',
      'marzo',
      'abril',
      'mayo',
      'junio',
      'julio',
      'agosto',
      'septiembre',
      'octubre',
      'noviembre',
      'diciembre',
    ]
    return {
      dia: parseInt(day),
      mes: meses[parseInt(month)],
      anio: year,
    }
  }

  get LineaEnBlanco() {
    return new Paragraph({
      children: [],
      spacing: { after: 600 },
    })
  }

  get NumeroOficio() {
    const NUMERO_OFICIO = 'SSC/DA/****/2025.'

    return new Paragraph({
      children: [new BaseText('OFICIO NÚM: ', { bold: true }).value, new BaseText(NUMERO_OFICIO).value],
      alignment: 'end',
    })
  }
  get Asunto() {
    const ASUNTO = 'CONSTANCIA DE NO ADEUDO.'
    return new Paragraph({
      children: [new BaseText('ASUNTO: ', { bold: true }).value, new BaseText(ASUNTO).value],
      alignment: 'end',
    })
  }
  get Saludo() {
    return new Paragraph({
      children: [
        new BaseText('A QUIEN CORRESPONDA:', {
          bold: true,
        }).value,
      ],
      alignment: 'start',
    })
  }
  get Cuerpo() {
    const { dia, mes, anio } = this.formatearFechaLarga(this.fecha)
    return [
      new Paragraph({
        children: [
          new BaseText(
            `La que suscribe, encargada del Departamento de Armamento y Municiones de esta Secretaria, hago constar que el C. `,
            { size: 22 }
          ).value,
          new BaseText(this.nombre, { size: 22 }, { underline: true }).value,
          new BaseText(', quien se desempeñó como POLICIA, en el', { size: 22 }).value,
          new BaseText(' área: ', { size: 22 }).value,
          new BaseText(this.area, { size: 22 }, { underline: true }).value,
          new BaseText(
            ', DE LA SECRETARIA DE SEGURIDAD CIUDADANA, no tiene adeudo alguno pendiente de liquidar en este Departamento.',
            { size: 22 }
          ).value,
          new BaseText(
            'El presente documento no exime al beneficiario del mismo, de cualquier otra responsabilidad que se derive en revisión posterior al desempeño de sus funciones, conforme a lo establecido en la ley de Responsabilidades de los Servidores Públicos vigentes en el Estado.',
            { size: 22 }
          ).value,
          new BaseText(
            'Para los fines legales que procedan, se extiende la presente CONSTANCIA DE NO ADEUDO, en la Ciudad de Tlaxcala, Tlax. al dia ',
            { size: 22 }
          ).value,
          new BaseText(` ${dia}`, { size: 22 }, { underline: true }).value,
          new BaseText(', del mes de ', { size: 22 }).value,
          new BaseText(`${mes}`, { size: 22 }, { underline: true }).value,
          new BaseText(', del año ', { size: 22 }).value,
          new BaseText(`${anio}`, { size: 22 }, { underline: true }).value,
        ],
        alignment: AlignmentType.JUSTIFIED,
      }),
      this.LineaEnBlanco,
      new Paragraph({
        children: [new BaseText('Sin otro particular, le envio un cordial saludo.', { size: 22 }).value],
      }),
    ]
  }

  get Firmas() {
    return new Table({
      rows: [
        new TableRow({
          children: [
            new TableCell({
              children: [
                new Paragraph({
                  children: [new BaseText('ELABORÓ', { bold: true }).value],
                  alignment: AlignmentType.CENTER,
                }),
                new Paragraph({ children: [], spacing: { after: 300 } }),
                new Paragraph({
                  children: [new BaseText('Eli Piña Romano', { size: 22 }, { bold: true }).value],
                  alignment: AlignmentType.CENTER,
                }),
                new Paragraph({
                  children: [
                    new BaseText(
                      'Adscrita al Departamento de Armamento y Municiones de la S.S.C.',
                      { size: 22 },
                      { bold: true }
                    ).value,
                  ],
                  alignment: AlignmentType.CENTER,
                }),
              ],
              verticalAlign: 'center',
            }),
            new TableCell({
              children: [],
              verticalAlign: 'center',
            }),
            new TableCell({
              children: [
                new Paragraph({
                  children: [new BaseText('REVISÓ', { bold: true }).value],
                  alignment: AlignmentType.CENTER,
                }),
                new Paragraph({ children: [], spacing: { after: 300 } }),
                new Paragraph({
                  children: [new BaseText('Victor Hernandez Pedraza', { size: 22 }, { bold: true }).value],
                  alignment: AlignmentType.CENTER,
                }),
                new Paragraph({
                  children: [
                    new BaseText(
                      'Responsable de turno en el Departamento de Armamento y Municiones',
                      { size: 22 },
                      { bold: true }
                    ).value,
                  ],
                  alignment: AlignmentType.CENTER,
                }),
              ],
              verticalAlign: 'center',
            }),
          ],
        }),
        new TableRow({
          children: [
            new TableCell({
              columnSpan: 3,
              children: [
                new Paragraph({
                  children: [],
                  spacing: { after: 400 },
                }),
              ],
              verticalAlign: 'center',
            }),
          ],
        }),
        new TableRow({
          children: [
            new TableCell({
              columnSpan: 3,
              children: [
                new Paragraph({
                  children: [new BaseText('ATENTAMENTE', { bold: true }).value],
                  alignment: AlignmentType.CENTER,
                }),
                new Paragraph({ children: [], spacing: { after: 300 } }),
                new Paragraph({
                  children: [new BaseText('Flor Alicia Guzmán', { size: 22 }, { bold: true }).value],
                  alignment: AlignmentType.CENTER,
                }),
                new Paragraph({
                  children: [new BaseText('Encargada del Departamento de', { size: 22 }, { bold: true }).value],
                  alignment: AlignmentType.CENTER,
                }),
                new Paragraph({
                  children: [new BaseText('Armamento y Municiones', { size: 22 }, { bold: true }).value],
                  alignment: AlignmentType.CENTER,
                }),
                new Paragraph({
                  children: [
                    new BaseText('de la Secretaria de Seguridad Ciudadana', { size: 22 }, { bold: true }).value,
                  ],
                  alignment: AlignmentType.CENTER,
                }),
              ],
              verticalAlign: 'center',
            }),
          ],
        }),
      ],
      width: {
        size: 100,
        type: 'pct',
      },
      borders: {
        top: { style: 'none', size: 0, color: 'FFFFFF' },
        bottom: { style: 'none', size: 0, color: 'FFFFFF' },
        left: { style: 'none', size: 0, color: 'FFFFFF' },
        right: { style: 'none', size: 0, color: 'FFFFFF' },
        insideHorizontal: { style: 'none', size: 0, color: 'FFFFFF' },
        insideVertical: { style: 'none', size: 0, color: 'FFFFFF' },
      },
    })
  }

  async MarcaAgua() {
    const watermarkBuffer = await fetch(watermarkLogo)
      .then((r) => r.blob())
      .then((b) => b.arrayBuffer())

    return new Paragraph({
      children: [
        new ImageRun({
          data: watermarkBuffer,
          type: 'png',
          transformation: {
            width: 300,
            height: 600,
          },
          floating: {
            horizontalPosition: {
              align: 'left',
            },
            verticalPosition: {
              align: 'center',
            },
            behindDocument: true,
          },
          transparency: 0.18,
        }),
      ],
    })
  }
  async generate() {
    try {
      const sscLogoBuffer = await fetch(sscLogo)
        .then((r) => r.blob())
        .then((b) => b.arrayBuffer())

      const tlaxcalaLogoBuffer = await fetch(tlaxcalaLogo)
        .then((r) => r.blob())
        .then((b) => b.arrayBuffer())

      const marcaAgua = await this.MarcaAgua()

      const footer = await BaseFooter.generate()

      const document = new Document({
        sections: [
          {
            properties: { page: { size: { ...LETTER_PAGE_SIZE } } },
            headers: { default: new BaseHeader(sscLogoBuffer, tlaxcalaLogoBuffer) },
            children: [
              marcaAgua,
              this.NumeroOficio,
              this.Asunto,
              this.Fecha,
              this.LineaEnBlanco,
              this.Saludo,
              this.LineaEnBlanco,
              ...this.Cuerpo,
              this.LineaEnBlanco,
              this.Firmas,
            ],
            footers: { default: footer },
          },
        ],
      })

      return document
    } catch (error) {
      console.error('Error generating ConstanciaNoAdeudoArmeria document:', error)
      throw error
    }
  }
}
export default ConstanciaNoAdeudoArmeria
